/* tslint:disable */
/* eslint-disable */
/**
 * ファイル管理ポータル クライアントAPI
 * ファイル管理ポータル Webクライアント向けAPI 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: TODO@graat.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * サービスプロジェクトステータス情報
 * @export
 * @interface ServiceProjectStatusResponse
 */
export interface ServiceProjectStatusResponse {
    /**
     * アクセスポイント
     * @type {string}
     * @memberof ServiceProjectStatusResponse
     */
    'access_point'?: string;
    /**
     * サービスプロジェクトステータス - OPEN:利用中 - FROZEN:凍結 - CLOSED:閉鎖 - DELETE:削除 
     * @type {string}
     * @memberof ServiceProjectStatusResponse
     */
    'service_project_status'?: ServiceProjectStatusResponseServiceProjectStatusEnum;
}

export const ServiceProjectStatusResponseServiceProjectStatusEnum = {
    Open: 'OPEN',
    Frozen: 'FROZEN',
    Closed: 'CLOSED',
    Delete: 'DELETE'
} as const;

export type ServiceProjectStatusResponseServiceProjectStatusEnum = typeof ServiceProjectStatusResponseServiceProjectStatusEnum[keyof typeof ServiceProjectStatusResponseServiceProjectStatusEnum];


